<div class="auth-page">
  <div class="container page">
    <div class="row">
      <div class="col-md-6 offset-md-3 col-xs-12">
        <h1 class="text-xs-center">Register</h1>
        <p class="text-xs-center">
          <a [routerLink]="['/login']">Have an account ?</a>
        </p>
        <app-error-message *ngIf="backendErrors$ | async" [errors]="backendErrors$ | async"></app-error-message>
        <form [formGroup]="form" (ngSubmit)="onSubmit($event)">
          <fieldset>
            <fieldset class="form-group">
              <input type="text" class="form-control form-control-md" placeholder="Username" formControlName="username" />
            </fieldset>
            <fieldset class="form-group">
              <input type="email" class="form-control form-control-md" placeholder="Email" formControlName="email" />
            </fieldset>
            <fieldset class="form-group">
              <input type="password" class="form-control form-control-md" placeholder="Password" formControlName="password" />
            </fieldset>

            <button [disabled]="form.invalid || (isSubmitting$ | async)" class="btn btn-md btn-primary pull-xs-right" type="submit">
              Sign up
            </button>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</div>
